import debounce from 'lodash/debounce';
import { setMaxHeightStyle } from '../../scripts/utils/setMaxHeightStyle';

export const initCollapsibleRows = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-collapsible-row-body]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};
